<template>
  <div>
    <div class="error-container">
      <div class="error-info">
        <div class="error-icon"><mtd-icon name="info-circle-o"/></div>
        <div class="error-title"><span>{{ $getText('ws_mobile_load_failed', '加载失败') }}</span></div>
        <div class="error-tips">
          <span>{{ $getText('ws_mobile_page_load_failed_tips_retry', '页面加载失败，请重试') }}</span>
          <br/>
          <span>{{ $getText('ws_mobile_page_load_failed_tips_help', '或复制并打开如下网址查看操作步骤') + 'https://km.sankuai.com/page/18283035' }}</span>
        </div>
        <div style="text-align: center;margin-top: 32px">
          <mtd-button class="btn-demo-item" ghost type="primary" size="large" @click="this.$router.go(-1)">{{ $getText('ws_mobile_retry', '重试') }}</mtd-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: "mobile_404"
    }
</script>

<style scoped>
  .error-container {
    margin-top: 40%;
  }
  .error-icon {
    font-size: 72px;
    text-align: center;
    color: #C2C2C2;
  }
  .error-title {
    text-align: center;
    font-family: PingFang SC, sans-serif;
    font-size: 18px;
    color: rgba(0,0,0,0.84);
    letter-spacing: 0;
    font-weight: 500;
    line-height: 25px;
    margin-bottom: 16px;
  }
  .error-tips {
    padding: 0 16px;
    width: 250px;
    font-family: PingFang SC, sans-serif;
    font-size: 12px;
    color: rgba(0,0,0,0.84);
    letter-spacing: 0;
    text-align: center;
    font-weight: 400;
    line-height: 17px;
    margin: auto;
  }
</style>
